module.exports = __webpack_public_path__ + "static/DHCM4-21be046e51e857bc9fa91d24cfeb7c44.png";